import * as React from 'react';
import {useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import {FormControl, TextField} from "@mui/material";

const CustomAutocomplete = ({items, name, onSelect, loading}) => {
    const [value, setValue] = useState(null);

    const handleChange = (event, newValue) => {
        if (!newValue){
            setValue(newValue);
            onSelect(event, newValue)
        }else{
            setValue(newValue);
            onSelect(event, newValue.id)
        }
    };

    if (loading) {
        return (
            <CircularProgress/>
        )
    } else {
        return (<FormControl sx={{m: 0, minWidth: 300}} size="small">
            <Autocomplete
                disablePortal
                options={items}
                onChange={handleChange}
                value={value}
                getOptionLabel={(option) => option ? option.id : ""}
                isOptionEqualToValue={(option, value) => option.id === value.id} // Compare by id
                renderOption={(props, option) => (
                    <li {...props}>
                        {option.name}
                    </li>
                )}
                filterOptions={(opts, {inputValue}) =>
                    opts.filter(
                        (option) =>
                            option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                            option.id.toString().includes(inputValue) // Allows searching by ID as well
                    )
                }
                renderInput={(params) => (
                    <TextField {...params} label="Campaign" variant="standard" value={value ? value.name : ""} />
                )}

            />
        </FormControl>)
    }

}

export default CustomAutocomplete